import { uuid } from "../../../../../types/veboxModels";

export interface JSONLocationSuggestion {
	id: number;
	guid: uuid;
	name: string;
	type: SUGGESTION_TYPES;
	localizedType: string;
}

export enum SUGGESTION_TYPES {
	COUNTRY = "Country",
	REGION = "Region",
	PROVINCE = "Province",
	CITY = "City",
	ZIP_CODE = "Zip Code",
	ADDRESS = "Address",
	LOCATION = "Location",
}
